import { CardStyleInterpolators } from "@react-navigation/stack";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { StockCountActionsScreen } from "../StockCountActionsScreen";
import { ScanModeSelectScreen } from "../ScanModeSelectScreen";
import { StockCountActionsRootScreenParamList } from "../../../../types";

export interface StockCountActionsRootScreenProps {}

export const StockCountActionsRootScreen = (
  props: StockCountActionsRootScreenProps
) => {
  const RootNavigator =
    createStackHeaderNavigator<StockCountActionsRootScreenParamList>();

  return (
    <RootNavigator.Navigator>
      <RootNavigator.Group
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          headerShown: true,
          title: "",
        }}
      >
        <RootNavigator.Screen
          // options={{ title: "More Actions" }}
          name="StockCountActionsScreen"
          component={StockCountActionsScreen}
          options={{
            headerLeft: () => <ModalCloseButton type="Close" />,
          }}
        />
        <RootNavigator.Screen
          name="ScanModeSelectScreen"
          component={ScanModeSelectScreen}
          options={{
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        />
      </RootNavigator.Group>
    </RootNavigator.Navigator>
  );
};
